const DataProtection = () => {
  return (
    <div className="mb-8">
      <h2 id="data-protection" className="text-2xl font-semibold mb-4">Data Protection</h2>
      <p className="mb-6">
        We implement appropriate technical and organizational security measures to protect your personal data against accidental or unlawful destruction, loss, alteration, unauthorized disclosure, or access. Our security measures are continuously improved in line with technological developments.
      </p>
      <p className="mb-6">
        Please note that any data transmission over the Internet (including email) is generally not completely secure and we cannot guarantee the security of data transmitted over the Internet. While we will do our best to protect your personal information, transmission of personal information to and from our app is at your own risk.
      </p>
    </div>
  );
};

export default DataProtection;